// extracted by mini-css-extract-plugin
module.exports = {"social-btn":"socialLink_social-btn__1L6iL","facebook":"socialLink_facebook__2eTs1","google":"socialLink_google__3fVhC"};